const OVERRIDE_KEY = 'ff:webCollection'

/**
 * Marks the Collection tab's icon in whichever nav is on screen, so the earned-cards fan can
 * measure where to land. Declared here rather than in the feature: the navs are shared, and the
 * attribute is the contract between them.
 */
export const COLLECTION_ANCHOR_ATTR = 'data-collection-anchor'

/** Dev-only force, for previewing either arm without waiting to be bucketed. */
function devOverride(): boolean | undefined {
  if (!import.meta.env.DEV) return undefined
  try {
    const raw = localStorage
      .getItem(OVERRIDE_KEY)
      ?.trim()
      .replace(/^["']|["']$/g, '')
      .toLowerCase()
    if (raw === 'true' || raw === '1') return true
    if (raw === 'false' || raw === '0') return false
    return undefined
  } catch {
    return undefined
  }
}

/**
 * Whether the Collection takes Discover's tab slot.
 *
 * Two conditions, as on Android: the plan has to carry a collection — the server's allowlist,
 * which a plan switch flips with no config round-trip — AND the test has to have put this person in
 * the arm. The allowlist alone is not the experiment: without [isMasteryArm] the control group is
 * served the treatment and loses Discover, which both corrupts the test and takes content away.
 *
 * [hasCollection] is `activePlan.hasCollection`, the same field Android and iOS decide on, so all
 * three platforms sit in one experiment rather than three.
 *
 * Browser support is deliberately NOT part of the answer. The Collection renders through Compose,
 * but the tab opens onto the unsupported screen, which says as much; withholding it and keeping
 * Discover left people with no way to learn their browser is the problem. Someone told early beats
 * someone quietly served something else.
 */
export function showsCollectionTab(
  hasCollection: boolean,
  isMasteryArm: boolean,
): boolean {
  return devOverride() ?? (hasCollection && isMasteryArm)
}
